/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SyncCompaniesToKlaviyoResult
 */
export interface SyncCompaniesToKlaviyoResult {
  /**
   *
   * @type {string}
   * @memberof SyncCompaniesToKlaviyoResult
   */
  listId: string;
  /**
   *
   * @type {string}
   * @memberof SyncCompaniesToKlaviyoResult
   */
  listName: string;
  /**
   *
   * @type {number}
   * @memberof SyncCompaniesToKlaviyoResult
   */
  companiesProcessed: number;
  /**
   *
   * @type {number}
   * @memberof SyncCompaniesToKlaviyoResult
   */
  contactsQueued: number;
  /**
   *
   * @type {number}
   * @memberof SyncCompaniesToKlaviyoResult
   */
  companiesSkippedUnverified: number;
  /**
   *
   * @type {number}
   * @memberof SyncCompaniesToKlaviyoResult
   */
  companiesSkippedDead: number;
  /**
   *
   * @type {number}
   * @memberof SyncCompaniesToKlaviyoResult
   */
  contactsSkippedNoEmail: number;
}

/**
 * Check if a given object implements the SyncCompaniesToKlaviyoResult interface.
 */
export function instanceOfSyncCompaniesToKlaviyoResult(
  value: object,
): value is SyncCompaniesToKlaviyoResult {
  if (!("listId" in value) || value["listId"] === undefined) return false;
  if (!("listName" in value) || value["listName"] === undefined) return false;
  if (
    !("companiesProcessed" in value) ||
    value["companiesProcessed"] === undefined
  )
    return false;
  if (!("contactsQueued" in value) || value["contactsQueued"] === undefined)
    return false;
  if (
    !("companiesSkippedUnverified" in value) ||
    value["companiesSkippedUnverified"] === undefined
  )
    return false;
  if (
    !("companiesSkippedDead" in value) ||
    value["companiesSkippedDead"] === undefined
  )
    return false;
  if (
    !("contactsSkippedNoEmail" in value) ||
    value["contactsSkippedNoEmail"] === undefined
  )
    return false;
  return true;
}

export function SyncCompaniesToKlaviyoResultFromJSON(
  json: any,
): SyncCompaniesToKlaviyoResult {
  return SyncCompaniesToKlaviyoResultFromJSONTyped(json, false);
}

export function SyncCompaniesToKlaviyoResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SyncCompaniesToKlaviyoResult {
  if (json == null) {
    return json;
  }
  return {
    listId: json["listId"],
    listName: json["listName"],
    companiesProcessed: json["companiesProcessed"],
    contactsQueued: json["contactsQueued"],
    companiesSkippedUnverified: json["companiesSkippedUnverified"],
    companiesSkippedDead: json["companiesSkippedDead"],
    contactsSkippedNoEmail: json["contactsSkippedNoEmail"],
  };
}

export function SyncCompaniesToKlaviyoResultToJSON(
  json: any,
): SyncCompaniesToKlaviyoResult {
  return SyncCompaniesToKlaviyoResultToJSONTyped(json, false);
}

export function SyncCompaniesToKlaviyoResultToJSONTyped(
  value?: SyncCompaniesToKlaviyoResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    listId: value["listId"],
    listName: value["listName"],
    companiesProcessed: value["companiesProcessed"],
    contactsQueued: value["contactsQueued"],
    companiesSkippedUnverified: value["companiesSkippedUnverified"],
    companiesSkippedDead: value["companiesSkippedDead"],
    contactsSkippedNoEmail: value["contactsSkippedNoEmail"],
  };
}
